export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Құпиясөз"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бас тарту"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жалғастыру"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Екінші құпия сөзіңізді енгізіңіз"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Екінші құпия сөз"])}
}